import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { useContext, useMemo, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import GenericCard from '../../components/GenericCards/GenericCards';
import GenericList, {
  GenericListItem,
} from '../../components/GenericList';
import Link from '../../components/Link';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/Button';
import DefaultCard from '../../components/DefaultCard';
import PopoverWithLinks from '../widgets/PopoverLinks/PopoverLinks';
import { AuthStore } from '../../providers/auth';
import {
  EnrollmentProvider,
  EnrollmentStore,
} from '../../providers/enrollment';
import { FamilyMembersProvider } from '../../providers/familyMembers';
import {
  addOrRemoveDaysToGivenDate,
  formatDate,
} from '../../utils/utils';
import EnrollmentSuccess from '../widgets/EnrollmentSuccessPage/EnrollmentSuccess';
import {
  COBRA_BENEFITS_ENROLLMENT_ROUTE,
  BENEFIT_EELECTION_HISTORY_ROUTE
} from '../../routes/types';

const alertsData: any[] = [
  {
    alertDescription:
      'Make your initial COBRA payment for all your benefits elections to go into effect.',
  },
];

const linksData = [
  {
    linkHeader: 'Election History',
    route: BENEFIT_EELECTION_HISTORY_ROUTE,
    modal: false,
  },
];

const genericListContent = [
  {
    linkTitle: 'Contacts',
    linkRIcon: light('chevron-right'),
    url: 'resources/contacts',
  },

  {
    linkTitle: 'Info/Forms',
    linkRIcon: light('chevron-right'),
    url: 'resources/documents',
  },

];

function CobraBenefitsEnrollmentView({ setSubmitted }: any) {
  const navigate = useNavigate();
  const [,] = useContext(AuthStore) || [];
  const {
    activeHealthBenefits,
  } = useContext(EnrollmentStore) || {};


  const healthBenefits = useMemo(() => {
    const plans = activeHealthBenefits.filter(
      (e: any) => e.type !== 'health-savings'
    );

    return plans;
  }, [activeHealthBenefits]);

  let shouldHaveHealthBenefitsWarnings = false;
  healthBenefits.forEach((b: any) => {
    if (!b['plan']['id'].includes('Coverage'))
      shouldHaveHealthBenefitsWarnings = true;
  });

  let currentAlerts: Array<any> = [];
  if (shouldHaveHealthBenefitsWarnings) {
    currentAlerts = [...alertsData];
  }

  return (
    <Container className="cnd-custom-container-large mb-12 px-lg-9 px-xl-0">
      <Row className={'mt-7 mt-lg-13'}>
        <Col
          sm={12}
          lg={8}
          className={
            'd-flex justify-content-between align-items-center pt-lg-8'
          }
        >   
          <h4 className={'h4 fw-light mb-0'}>{'Current Benefits'}</h4>
          <div className={'d-flex align-items-center ms-3'}>
            <PopoverWithLinks linksData={linksData} />
          </div>
          
        </Col>
      </Row>
      <Row className={'mt-10'}>
        <Col sm={12} lg={8}>
            <GenericCard
              className={'p-10'}
              variant="white"
              style={{ zIndex: '1000' }}
            > 
            <p>Our record show you have no current benefit elections at this time.</p>
          </GenericCard>

        </Col>
        <Col sm={12} lg={4} className={'mt-11 mt-lg-0'}>
          <DefaultCard
              isCurrentEvent
              className="flex-column h-100"
              variant="blue"
              leftHeading={<div className="text-sm-20-lg-32">Current Events</div>}
              leftSubheading={
                <Container className="p-0">
                  <Row className={'align-items-end'}>
                    <Col className={'col-8'}>
                      <Row>
                        <Col className="text-sm-12-lg-14 text-nowrap col-12 fw-normal">
                          Enroll in COBRA Coverage
                        </Col>
                        <Col className="text-caption text-nowrap col-7 fw-light">
                          {`Deadline: ${formatDate(
                            addOrRemoveDaysToGivenDate(new Date(), 25)
                          )}`}
                        </Col>
                        <Col className="pb-3 text-caption text-nowrap col-7 fw-light">
                          Status: Pending Payment
                        </Col>
                      </Row>
                    </Col>
                    <Col className={'col-4 mb-3 text-end'}>
                      <Button
                        onClick={() => navigate(COBRA_BENEFITS_ENROLLMENT_ROUTE)}
                        variant={'primary-shadow'}
                        size="sm"
                      >
                        Change
                      </Button>
                    </Col>
                  </Row>
                </Container>
              }
            />
          
        </Col>
      </Row>
      <Row className={'mt-10'}>
        <Col sm={12} lg={8}>

        </Col>
        <Col sm={12} lg={4} className={'mt-11 mt-lg-0'}>
        <h6 className={'fs-10'}>Helpful Information</h6>
          <GenericCard className={'mt-7'} variant={'white'}>
            <GenericList>
              

              {genericListContent.map((genericListItem, idx) => {
                return (
                  <GenericListItem key={idx}>
                    <Link
                      rightIcon={genericListItem.linkRIcon}
                      eventKey="test"
                      isAlignAtEnd
                      isBlue
                      isBlueIcon
                      className={'py-0'}
                      href={'#/'+genericListItem.url}
                    >
                      {genericListItem.linkTitle}
                    </Link>
                  </GenericListItem>
                );
              })}
            </GenericList>
          </GenericCard>    
        </Col>
      </Row>


    </Container>
  );
}

function CobraBenefitsEnrollment() {
  const [submmited, setSubmitted] = useState(false);

  return (
    <EnrollmentProvider>
      <FamilyMembersProvider>
        {!submmited ? (
          <CobraBenefitsEnrollmentView setSubmitted={setSubmitted} />
        ) : (
          <EnrollmentSuccess setSubmitted={setSubmitted} />
        )}
      </FamilyMembersProvider>
    </EnrollmentProvider>
  );
}

export default CobraBenefitsEnrollment;